import React, { useState } from "react";
import { BASE_URL } from "../../config/config";

const FileUploadComponent = ({ handleUpload, status }) => {
  const [files, setFiles] = useState([]);

  const onFileChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileUrl = URL.createObjectURL(selectedFile);

    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles, { file: selectedFile, url: fileUrl }];
      if (updatedFiles.length > 2) {
        return updatedFiles.slice(-2);
      }
      return updatedFiles;
    });
  };

  const handleDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group mb-2">
            <label htmlFor="fileUpload" style={{ marginBottom: "10px" }}>
              {"Upload National Id"}
            </label>
            <input
              id="nationalId"
              type="file"
              placeholder=""
              className="form-control"
              style={{ height: "33px" }}
              name="fileUpload"
              onChange={onFileChange}
            />
          </div>
        </div>
        {files != "" && <div className="col-md-12">
          <button
            className="btn btn-sm btn-primary mt-3"
            style={ files != "" ? { color: "white" } : {}}
            onClick={() => handleUpload(files)}
            disabled={files == ""}
          >
            Upload
          </button>
        </div>}
      </div>
      <div style={{ display: "flex" }}>
        {files.map((fileObj, index) => (
          <div key={index} style={{ marginTop: "10px", position: "relative" }}>
            <>
              <img
                src={fileObj.url}
                alt="receipt"
                style={{
                  width: "160px",
                  height: "160px",
                  padding: "5px",
                }}
              />
              <button
                style={{ position: "absolute", right: "5px", top: "5px" }}
                onClick={() => handleDelete(index)}
              >
                <div
                  style={{
                    backgroundColor: "red",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i className="fa fa-xmark"></i>
                </div>
              </button>
            </>
          </div>
        ))}
      </div>
        {status?.data?.status === false && (<div style={{ color: "red" }}>{status?.data?.data?.description == "fileSizeExceeded" ? "file size exceeded (Max 2MB)" : "something went wrong!"}</div>)}
    </div>
  );
};

export default FileUploadComponent;
